import classNames from 'classnames';
import styles from './index.module.sass';
import { RecipeWidget } from '../recipe-widget';
import { ArrowMulti } from '../../images';
import ArrowUp from '../../images/arrow-up.svg';
import { EqualSign } from '../../images';
import { useState } from 'react';

export const TopWidget = ({ data, activePair, setActivePair }: { data: any, activePair: number, setActivePair: (val: number) => void }) => {
  const [expanded, setExpanded] = useState(true);

  const bunkerReform = () => {
    const inputArray = data?.bunkers;
    if (inputArray?.[0]?.type === 2) {
        return inputArray?.map((item: any) => ({ model: item.model_name, type: 2}))
    }
    const pairedArray = [];

    for (let i = 0; i < inputArray?.length; i += 2) {
      if (i + 1 < inputArray?.length) {
        pairedArray.push([inputArray?.[i], inputArray?.[i + 1]]);
      }
    }
    return pairedArray;
  };
  return (
    <>
      <div className={styles.topWidget} style={{ width: expanded ? '100%' : 'auto' }}>
        <div className={classNames(styles.card, styles.cardBordered)}>
          <h3 className={styles.cardTitle} onClick={() => setExpanded(!expanded)}>
            Данные для миксования{' '}
            <img
              src={ArrowUp}
              className={classNames(styles.arrow)}
              style={{ transform: expanded ? 'none' : 'rotate(180deg)' }}
            />
          </h3>
          <div
            className={styles.cardBody}
            style={{ display: expanded ? 'flex' : 'none' }}
          >
            <RecipeWidget
              title={data?.part_one?.warehous_name}
              weight={data?.part_one?.weight}
              number={data?.part_one?.bag_arr?.length}
              temperature={data?.part_one?.params?.temperature}
              natura={data?.part_one?.params?.nature}
              idk={data?.part_one?.params?.idk}
              humidity={data?.part_one?.params?.humidity}
              gluten={data?.part_one?.params?.gluten}
              protein={data?.part_one?.params?.protein}
              fallingNumber={data?.part_one?.params?.cp}
              price={data?.part_one?.price}
            />
            <div className={styles.separatorImage}>
              <img src={ArrowMulti} alt="icon" />
            </div>
            <RecipeWidget
              title={data?.part_two?.warehous_name}
              weight={data?.part_two?.weight}
              number={data?.part_two?.bag_id}
              temperature={data?.part_two?.params?.temperature}
              natura={data?.part_two?.params?.nature}
              idk={data?.part_two?.params?.idk}
              humidity={data?.part_two?.params?.humidity}
              gluten={data?.part_two?.params?.gluten}
              protein={data?.part_two?.params?.protein}
              fallingNumber={data?.part_two?.params?.cp}
              price={data?.part_two?.price}
            />
            <div className={styles.separatorImage}>
              <img src={EqualSign} alt="icon" />
            </div>
            <RecipeWidget
              variant="profit"
              price={data?.result?.price}
              title={data?.result?.warehous_name}
              weight={data?.result?.weight}
              number={data?.result.bag_id}
              temperature={data?.result?.params?.temperature}
              natura={data?.result?.params?.nature}
              idk={data?.result?.params?.idk}
              humidity={data?.result?.params?.humidity}
              gluten={data?.result?.params?.gluten}
              protein={data?.result?.params?.protein}
              fallingNumber={data?.result?.params?.cp}
              priceAll={data?.result.price_all}
              stepsCount={data?.steps?.reduce((acc: number, item: any) => item.steps.length + acc, 0)}
            />
          </div>
        </div>
        <div className={styles.toggler} style={{ bottom: !expanded ? '-46px' : '-46px' }}>
          <div
            className={styles.selector}
            style={{ width: `${100 / bunkerReform().length}%`, left: `${100 / bunkerReform().length * activePair}%` }}
          ></div>
          {bunkerReform().map((item: any, i: number) => (
            <div className={styles.coupleItem} onClick={() => setActivePair(i)}> {item.type === 2 ? item.model : `пара ${i + 1}`}</div>
          ))}
        </div>
      </div>
    </>
  );
};
